export enum Brand {
  Frontnode = 'frontnode',
  Blockforia = 'blockforia',
  Omnidrive = 'omnidrive',
}
